/* eslint-disable import/no-cycle */
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { FlxStyleModule, FlxWrapperStyleDirective } from '@flowx/angular-theme'
import { CardFooterActionsTemplateConfig } from '@flowx/core-sdk'

import { FlxTreeNodeComponent } from '../../renderer/tree-node/tree-node.component'

@Component({
  selector: 'flx-card-footer-actions-wrapper',
  hostDirectives: [
    { directive: FlxWrapperStyleDirective, inputs: ['flxWrapperStyle: templateConfig'] },
  ],
  imports: [FlxTreeNodeComponent, FlxStyleModule],
  template: `
    <flx-tree-node
      [templateConfig]="templateConfig()"
      [flxLayoutStyle]="{ style: style(), componentType: 'card-footer-actions' }"
      class="flx-card-footer-actions"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxCardFooterActionsWrapperComponent {
  templateConfig = input.required<CardFooterActionsTemplateConfig>()

  displayOptions = computed(() => this.templateConfig().displayOptions)
  style = computed(() => this.displayOptions().style)
}
